// imports
import { FC } from 'react';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
// components
import SidebarMain from 'components/common/SidebarMain';
import SidebarSubList from 'components/common/SubSidebar';
import {
  ExcipientIcon,
  ProductsIcon,
  BottleIcon,
  SweetenerIcon,
  SyrupIcon,
  CapsuleTypeIcon,
} from 'assets/svgs';
// constants
import {
  BOTTLE_TEXT,
  PRODUCT_TEXT,
  BOTTLE_SIZE_ROUTE,
  PRODUCT_TYPE_ROUTE,
  ADMIN_MANAGEMENT_LIST,
  SUPER_ADMIN_BOTTLE_LIST,
  PRODUCT_MANAGEMENT_LIST,
  EXCIPIENT_ROUTE,
  EXCIPIENT_TEXT,
  SUPER_ADMIN_EXCIPIENT_LIST,
  SUPER_ADMIN_SWEETENER_LIST,
  SWEETENER_SYSTEM_TEXT,
  SWEETENER_COMPONENT_ROUTE,
  PRODUCT_INGREDIENT_ROUTE,
  SUPER_ADMIN_SYRUP_BASE_LIST,
  SYRUP_BASE_TEXT,
  SAND_COATING_ROUTE,
  SUPER_ADMIN_SAND_COATING_LIST,
  SAND_COATING_TEXT,
  FLAVOR_LIST,
  CAPSULE_LIST,
  CAPSULE_TEXT,
  CAPSULE_TYPE_ROUTE,
  BASE_COATING_LIST,
} from 'constants/index';

const ManagementList: FC = () => (
  <>
    <SidebarMain list={ADMIN_MANAGEMENT_LIST} />

    <SidebarSubList
      defaultRoute={PRODUCT_TYPE_ROUTE}
      mainTitle={PRODUCT_TEXT}
      list={PRODUCT_MANAGEMENT_LIST}
      icon={ProductsIcon}
    />

    <SidebarSubList
      defaultRoute={EXCIPIENT_ROUTE}
      mainTitle={EXCIPIENT_TEXT}
      list={SUPER_ADMIN_EXCIPIENT_LIST}
      icon={ExcipientIcon}
    />

    <SidebarSubList
      defaultRoute={BOTTLE_SIZE_ROUTE}
      mainTitle={BOTTLE_TEXT}
      list={SUPER_ADMIN_BOTTLE_LIST}
      icon={BottleIcon}
    />

    <SidebarSubList
      defaultRoute={SWEETENER_COMPONENT_ROUTE}
      mainTitle={SWEETENER_SYSTEM_TEXT}
      list={SUPER_ADMIN_SWEETENER_LIST}
      icon={SweetenerIcon}
    />

    <SidebarMain list={FLAVOR_LIST} />

    <SidebarSubList
      icon={SyrupIcon}
      mainTitle={SYRUP_BASE_TEXT}
      list={SUPER_ADMIN_SYRUP_BASE_LIST}
      defaultRoute={PRODUCT_INGREDIENT_ROUTE}
    />

    <SidebarSubList
      icon={<HourglassBottomIcon />}
      mainTitle={SAND_COATING_TEXT}
      list={SUPER_ADMIN_SAND_COATING_LIST}
      defaultRoute={SAND_COATING_ROUTE}
    />

    <SidebarMain list={BASE_COATING_LIST} />

    <SidebarSubList
      list={CAPSULE_LIST}
      mainTitle={CAPSULE_TEXT}
      icon={<CapsuleTypeIcon />}
      defaultRoute={CAPSULE_TYPE_ROUTE}
    />
  </>
);

export default ManagementList;
